
//STYLES
import './Home.css'
import CatLink from '../../../components/bar/CatLink'

//COMPONENTS

export default function Home( {categories} ) {

  return (
    <div className='home-page'>
      <ul>
        { categories && categories.map( (cat) => (
          <CatLink 
            key={cat.id}
            category={cat}/>
        )) }
      </ul>
    </div>
  )
}
